/* eslint-disable */
import _ from 'underscore';
var escapeMap = {
  '<': '&lt;',
  '>': '&gt;'
};
var regObj = {};
_.each(escapeMap, function (val, key) {
  regObj[key] = new RegExp(key, 'g');
});
var escapeHtmlEntities = function (str) {
  if (str) {
    _.each(escapeMap, function (escapedVal, key) {
      str = str.replace(regObj[key], escapedVal);
    });
  }
  return str;
};
export default {
  escape: escapeHtmlEntities
};

